/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { colors } from '../../config/theme';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  prereg: {
    width: '80%',
    margin: 'auto',
    backgroundColor: 'white',
    padding: '40px'
  },
  field: {
    marginBottom: '15px',
    alignItems: 'self-start'
  },
  fieldLabel: {
    fontFamily: 'GTAR',
    color: colors.mineShaft,
    fontSize: '14px',
    //lineHeight: 1.43,
    marginBottom: 0,
    marginTop: '-1px'
  },
  radioInput: {
    marginRight: '8px !important'
  },
  yellowWarning: {
    '& g': {
      '& path:nth-child(2)': {
        fill: colors.lightningYellow
      }
    }
  },
  btn: {
    padding: '7px 15px 9px',
    backgroundColor: 'white',
    border: '1px solid',
    color: '#959595',
    fontSize: '16px',
    fontWeight: 500,
    height: '40px',
    marginRight: '16px',
    cursor: 'pointer'
  },
  submit: {
    backgroundColor: 'black',
    color: 'white'
  },
  footer: {
    fontSize: '12px',
    color: '#959595',
    marginTop: '24px',
    borderTop: 'solid 1px #eeeeee',
    textAlign: 'right',
    paddingTop: '20px',
    paddingRight: '56px'
  }
});

export default useStyles;
